var render = function render(){var _vm=this,_c=_vm._self._c;return _c('bar-chart',{ref:"bigChart",attrs:{"height":350,"chart-data":_vm.bigBarChart.chartData,"extra-options":_vm.bigBarChart.extraOptions}})
}
var staticRenderFns = []

export { render, staticRenderFns }